import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
    selector: 'app-discover-executor',
    templateUrl: './discover-executor.component.html',
    styleUrls: ['./discover-executor.component.scss']
})
export class DiscoverExecutorComponent implements OnInit {

    @Input() api: any;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() showActionText = true;
    @Input() serviceProviderImages = {};
    @Output() dependencies: EventEmitter<any> = new EventEmitter<any>();
    @Output() usages: EventEmitter<any> = new EventEmitter<any>();
    @Output() isEditAPIDefClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() isAPIMgmtClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() isAPIDocTestClicked: EventEmitter<any> = new EventEmitter<any>();

    constructor(public platform: LeftpanelComponent) {
    }

    ngOnInit() {
    }

    getIconClass(type) {
        switch (type) {
            case 'API':
                return 'fa fa-table';
            case 'BUSINESSLOGIC':
                return 'fa fa-link';
            case 'SQLQUERY':
                return 'fa fa-database';
            case 'TESTSUITE':
                return 'fa fa-check-circle';
            case 'WORKFLOW':
                return 'fa fa-sitemap';
        }
    }

    getMethodClass(method) {
        switch (method) {
            case 'GET':
                return 'get';
            case 'PUT':
                return 'put';
            case 'POST':
                return 'post';
            case 'DELETE':
                return 'delete';
            case 'PATCH':
                return 'patch';
        }
    }

    getMethodName(method, entityname) {
        return method.toLowerCase() + entityname;
    }

    findDependencies(entity, key) {
        this.dependencies.emit({entity: entity, key: key});
    }

    findUsages(entity, key) {
        this.usages.emit({entity: entity, key: key});
    }
}
